export interface VitalSignsFormData {
  ID: string | number | null;
  CTIME: Date | null;
  CUSER: string;
  PT_ID: number | null;
  BODY_TEMPERATURE: string;
  MEAS_METHOD_OF_BODY_TEMP: string;
  HEART_RATE: string;
  HEART_RATE_TYPE: string;
  SYS: string;
  DIA: string;
  RESPIRATORY_COUNT: string;
  RESPIRATORY_COUNT_TYPE: string;
  RESPIRATORY_DISTRESS: string;
  SIYONEZE_CIRCULATION_DISORDER: string;
  IS_TAKEN_O2: string;
  O2_AMOUNT: string;
  O2_UNIT: string;
  LEVEL_OF_CONSCIOUSNESS: string;
  PAIN_LEVEL: string;
  DEFAKASYON: string;
  URINE: string;
  EARLY_WARNING_SCORE: string;
  WRITE_ON_EPICRISE: string;
  UPN: string;
  O2_SATURUZATION: string;
  PTIME: Date | null;
  CAPILLARY_CIRCULATION: string;
  BIRTH_PAIN: string;
  BIRTH_LOSIA: string;
  BIRTH_PROTEINURIA: string;
  KOAH_SATURATION: string;
  EVAULATION: string;
}

export interface VitalSignsCreateProps {
  recordId?: number | string;
  patientId?: number;
  patientData?: any;
  onChange?: (data: any) => void;
  formData?: any;
  onClose?: () => void;
  onSave?: () => void;
  extraAccess?: boolean;
  save?: (id?: string) => Promise<void>;
  isSaving?: boolean;
  getComId?: () => Promise<number | null>;
  comId?: number;
  setComId?: (comId: number | any) => void;
  getCardTableData?: (comId: number) => Promise<string | "">;
  createTableMasterId?: () => Promise<string | null>;
  handleChange?: (field: any, value: any) => void;
}

export const KOAH_CODES = [
  "J44.0",
  "J44.1",
  "J44.8",
  "J44.9",
  "J43.0",
  "J43.1",
  "J43.2",
  "J43.3",
  "J43.4",
  "J43.5",
  "J43.6",
  "J43.7",
  "J43.8",
  "J43.9",
  "J43.0",
];

export interface ModalState {
  open: boolean;
  title: string;
  recordId?: number;
  formData: any;
}

export interface DeleteState {
  open: boolean;
  itemId: string | null;
}

export interface AlertState {
  open: boolean;
  message: string;
  type: "success" | "error";
}